import React, { useEffect, useState, useRef } from 'react';
import { Result, Button, Pagination, Cascader, Select } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './index.module.scss';
import SearchConponent from '@/components/SearchConponent/SearchConponent';
import { setSearchValue, setClassificationText } from '@/store/slices/searchBarSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearSearchValue, clearClassificationText } from '@/store/slices/searchBarSlice';
import { getProductList } from '@/api/products';
import { getWebServiceProduct } from '@/api/Services';
import { getWebStoreList } from '@/api/store';
import { getProductCategoryAllList, getProductBrandAllList } from '@/api/products';
import ProductList from '../Home/components/ProductList/ProductList';

import ServiceProductList from "@/components/ServiceProductList/ServiceProductList";
import { IStoreDataAll } from '@/components/StoreList/types';




import StoreList from "@/components/StoreList/StoreList";
import { useTranslation } from 'react-i18next';

//级联选择器选项类型
interface CascaderOption {
  value: number;
  label: string;
  children?: CascaderOption[];
  isLeaf?: boolean;
}


//级联选择器选项类型
interface IClassification {
  is_active: boolean;
  is_delete: boolean;
  order: any;
  parent_id: number;
  product_category_id: number;
  product_category_name: string;
  child?: IClassification[];
}



const SearchList: React.FC = () => {


  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  useEffect(() => { 
    setTabs([
    { label: t('common.Product'), value: '1' },
    { label: t('common.Service'), value: '2' },
    { label: t('common.Store'), value: '3' },
  ])
  setStoreTypeOptions([
    { value: 1, label: t('searchList.individual') },
    { value: 2, label: t('searchList.business') },
  ])
  }, [i18n.language]);
  const [tabs, setTabs] = useState([
    { label: t('common.Product'), value: '1' },
    { label: t('common.Service'), value: '2' },
    { label: t('common.Store'), value: '3' },
  ]);
  //店铺类型
  const [storeTypeOptions, setStoreTypeOptions] = useState([
    { value: 1, label: t('searchList.individual') },
    { value: 2, label: t('searchList.business') },
  ]);
  //tabs选中的索引
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  
  // 筛选按钮选中状态
  const [selectedFilter, setSelectedFilter] = useState('Comprehensive');
  
  // 处理筛选按钮点击
  const handleFilterClick = (filterType: string) => {
    setSelectedFilter(filterType);
    // 这里可以添加相应的筛选逻辑
    console.log('Selected filter:', filterType);
  };
  
  const handleTabClick = (index: number) => {
    setKeyword('__CLEAR__');
    setTimeout(() => {
      setKeyword('');
    }, 0);
    
    setCascaderValue([]);
    setBrandList([]);
    
    // 清空所有查询条件
    setActiveTabIndex(index);
    
    if (index === 0) {
      // 商品列表
      const myParams = {
        product_category_id: '',
        page_num: 1,
        page_size: 20,
        product_category_brand_id: '',
        total: 0,
        totalPages: 0,
        product_title: ''
      };
      setParams(myParams);
      getProductListFn(myParams);
    } else if (index === 1) {
      // 服务列表
      const myParams = {
        product_category_id: '',
        pageNum: 1,
        pageSize: 20,
        total: 0,
        totalPages: 0,
        keyword: ''
      };
      setParamsService(myParams);
      getServiceProductListFn(myParams);
    } else if (index === 2) {
      // 店铺列表
      const myParams = {
        store_type: '',
        pageNum: 1,
        pageSize: 20,
        total: 0,
        totalPages: 0,
        keyword: ''
      };
      setParamsStore(myParams);
      getStoreListFn(myParams);
    }
    
    // 使用 navigate 跳转
    navigate(`/searchList?activeTabIndex=${index}`);
  }


  // 获取查询参数
  const [searchParams] = useSearchParams();


  //搜索回调
  const getMessage = (inputValue: string, tabIndex?: number): void => {
    // 如果传入了 tabIndex，则切换到对应的 tab
    if (tabIndex !== undefined && tabIndex !== activeTabIndex) {
      setActiveTabIndex(tabIndex);
    }
    
    const currentTabIndex = tabIndex !== undefined ? tabIndex : activeTabIndex;
    
    if (currentTabIndex === 0) {

      const myParams = {
        ...params,
        product_title: inputValue,
      };
      setParams(myParams);
      getProductListFn(myParams);

    } else if (currentTabIndex === 1) {
      const myParams = {
        ...paramsService,
        keyword: inputValue,
      };
      setParamsService(myParams);

      getServiceProductListFn(myParams);

    } else if (currentTabIndex === 2) {


      const myParams = {
        ...paramsStore,
        keyword: inputValue,
      };

      setParamsStore(myParams);

      getStoreListFn(myParams);

    }

  }


  const [params, setParams] = useState<any>({
    product_category_id: '',
    page_num: 1,
    page_size: 20,
    product_category_brand_id: '',
    total: 0,
    totalPages: 0,
    product_title: ''
  });

  //服务类商品入参
  const [paramsService, setParamsService] = useState<any>({
    product_category_id: '',
    pageNum: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
    keyword: ''
  });


  //店铺列表入参
  const [paramsStore, setParamsStore] = useState<any>({
    store_type: '',
    pageNum: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
    keyword: ''
  });


  // 搜索框内容
  const [keyword, setKeyword] = useState<string>('');

  // 分页信息
  const [goToPage, setGoToPage] = useState<string>('');

  //商品列表
  const [goodsList, setGoodsList] = useState([]);

  //服务商品列表
  const [serviceGoodsList, setServiceGoodsList] = useState([]);

  //店铺列表
  const [storeGoodsList, setStoreGoodsList] = useState<IStoreDataAll[]>([]);


  //获取商品列表方法
  const getProductListFn = (params: any) => {
    getProductList(params).then((res) => {
      if (res.code == 200) {
        setGoodsList(res.data);
        setParams((prevParams: any) => ({
          ...prevParams,
          page_num: params.page_num,
          total: res.total || 0,
          totalPages: res.totalPages || 1,
        }));
        setGoToPage('');
      }
    })
  }


  //获取服务商品列表方法
  const getServiceProductListFn = (params: any) => {
    console.log('getServiceProductListFn called with params:', params);
    getWebServiceProduct(params).then((res) => {
      console.log('getWebServiceProduct response:', res);
      if (res.code == 200) {
        setServiceGoodsList(res.data);
        setParamsService((prevParams: any) => ({
          ...prevParams,
          pageNum: params.pageNum,
          pageSize: params.pageSize,
          product_category_id: params.product_category_id,
          keyword: params.keyword,
          total: res.total || 0,
          totalPages: res.totalPages || 1,
        }));
        setGoToPage('');
      }
    })
  }


  //获取店铺列表方法
  const getStoreListFn = (params: any) => {
    getWebStoreList(params).then((res) => {
      if (res.code == 200) {
        setStoreGoodsList(res.data);
        setParamsStore((prevParams: any) => ({
          ...prevParams,
          pageNum: params.pageNum,
          total: res.total || 0,
          totalPages: res.totalPages || 1,
        }));
        setGoToPage('');
      }
    })
  }

  // 处理页码输入框回车事件
  const handlePageInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleGoToPage();
    }
  };

  // 分页变化
  const paginationChange = (page: number, pageSize: number) => {
    console.log('page', page, pageSize);

    if (activeTabIndex === 0) {

      const myParams = {
        ...params,
        page_num: page,
        page_size: pageSize,
      };
      setParams(myParams);
      getProductListFn(myParams);

    } else if (activeTabIndex === 1) {

      const myParams = {
        ...paramsService,
        pageNum: page,
        pageSize: pageSize,
      };
      setParamsService(myParams);

      getServiceProductListFn(myParams);

    } else if (activeTabIndex === 2) {
      const myParams = {
        ...paramsStore,
        pageNum: page,
        pageSize: pageSize,
      };

      setParamsStore(myParams);

      getStoreListFn(myParams);
    }

  };

  // 跳转到指定页
  const handleGoToPage = () => {
    const page = parseInt(goToPage);
    if (isNaN(page) || page < 1) {
      return;
    }



    if (activeTabIndex === 0) {


      if (page > params.totalPages) {
        return;
      }

      const myParams = {
        ...params,
        page_num: page,
      };
      setParams(myParams);
      getProductListFn(myParams);

    } else if (activeTabIndex === 1) {

      if (page > paramsService.totalPages) {
        return;
      }

      const myParams = {
        ...paramsService,
        pageNum: page,
      };
      setParamsService(myParams);

      getServiceProductListFn(myParams);

    } else if (activeTabIndex === 2) {

      if (page > paramsStore.totalPages) {
        return;
      }

      const myParams = {
        ...paramsStore,
        pageNum: page,
      };

      setParamsStore(myParams);

      getStoreListFn(myParams);

    }


  };




  // 商品分类相关逻辑商品分类相关逻辑

  //级联选项
  const [cascaderOptions, setCascaderOptions] = useState<CascaderOption[]>([]);

  // 级联选择器值
  const [cascaderValue, setCascaderValue] = useState<number[]>([]);


  // 将原始分类数据转换为Cascader需要的格式
  const transformToCascaderOptions = (data: IClassification[] = []): CascaderOption[] => {
    return data.map(item => {
      const hasChildren = item.child && item.child.length > 0;
      return {
        value: item.product_category_id,
        label: item.product_category_name,
        children: hasChildren ? transformToChildrenOptions(item.child) : undefined,
        isLeaf: !hasChildren // 如果没有子分类，则标记为叶子节点
      };
    });
  };

  // 转换子分类数据
  const transformToChildrenOptions = (children: IClassification[] = []): CascaderOption[] => {
    return children.map(child => {
      const hasChildren = child.child && child.child.length > 0;
      return {
        value: child.product_category_id,
        label: child.product_category_name,
        children: hasChildren ? transformToChildrenOptions(child.child) : undefined,
        isLeaf: !hasChildren // 如果没有子分类，则标记为叶子节点
      };
    });
  };

  // 查找第一条数据的最后一个节点
  const findLastNodePath = (data: IClassification[]): number[] => {
    if (!data || data.length === 0) return [];

    const path: number[] = [];
    let currentNode = data[0]; // 第一条数据
    path.push(currentNode.product_category_id);

    // 递归查找最深的子节点
    while (currentNode.child && currentNode.child.length > 0) {
      currentNode = currentNode.child[0];
      path.push(currentNode.product_category_id);
    }

    return path;
  };

  // 根据ID查找完整路径
  const findPathById = (options: CascaderOption[], targetId: number, currentPath: number[] = []): number[] | null => {
    for (const option of options) {
      // 尝试当前路径
      const newPath = [...currentPath, option.value];

      // 如果找到目标ID
      if (option.value === targetId) {
        return newPath;
      }

      // 如果有子节点，递归查找
      if (option.children && option.children.length > 0) {
        const result = findPathById(option.children, targetId, newPath);
        if (result) {
          return result;
        }
      }
    }

    return null;
  };

  // 根据最后一级ID查询完整路径
  // const path = findPathById(cascaderOptions, 1);


  // 显示分类路径
  const displayRender = (labels: string[]): string => {
    return labels.join(' > ');
  };

  // 处理分类选择
  const handleCascaderChange = (value: any, selectedOptions: any): void => {
    console.log(value, 'value');
    console.log(selectedOptions, 'selectedOptions');

    if (selectedOptions && selectedOptions.length > 0) {
      const lastOption = selectedOptions[selectedOptions.length - 1];
      // 只有当选择的是叶子节点时才设置值
      if (lastOption.isLeaf) {
        if (activeTabIndex === 0) {
          // 商品分类选择
          const myParams = {
            ...params,
            product_category_id: lastOption.value,//分类id
            product_category_brand_id: '',//品牌id
          }
          setParams(myParams);

          //获取品牌数据
          getBrandList(lastOption.value);
          
          // 调用API获取该分类下的产品列表
          getProductListFn(myParams);
        } else if (activeTabIndex === 1) {
          // 服务分类选择
          const myParams = {
            ...paramsService,
            product_category_id: lastOption.value,//分类id
          }
          setParamsService(myParams);
          
          // 调用API获取该分类下的服务列表
          getServiceProductListFn(myParams);
        }
      }
    }
  };


  // 商品分类相关逻辑商品分类相关逻辑




  //  Brand品牌相关逻辑 Brand品牌相关逻辑
  const [brandList, setBrandList] = useState<any[]>([]);

  const getBrandList = (product_category_id: number | null) => {
    getProductBrandAllList({
      product_category_id
    }).then((res) => {
      console.log(res, 'getProductBrandAllList');
      if (res.code === 200) {
        setBrandList(res.data);
      }
    });
  }


  //切换品牌
  //切换品牌
  const changeBrand = (value: number) => {
    console.log(value, 'changeBrand');
    const myParams = {
      ...params,
      product_category_brand_id: value,
    }
    setParams(myParams);
    
    // 调用API获取该品牌下的产品列表
    getProductListFn(myParams);
  }


  //  Brand品牌相关逻辑 Brand品牌相关逻辑


  //切换店铺类型

  const changeStoreType = (value: number) => {
    console.log(value, 'changeStoreType');
    const myParams = {
      ...paramsStore,
      store_type: value,
    }
    setParamsStore(myParams);
    
    // 调用API获取该店铺类型下的店铺列表
    getStoreListFn(myParams);
  }







  //重置
  const handleReset = () => {
    setKeyword('__CLEAR__');
    setTimeout(() => {
      setKeyword('');
    }, 0);
    
    setBrandList([]);
    setCascaderValue([]);

    setGoodsList([]);
    setServiceGoodsList([]);
    setStoreGoodsList([]);

    setGoToPage('');


    if (activeTabIndex === 0) {

      const myParams = {
        ...params,
        product_category_id: '',
        product_category_brand_id: '',
        product_title: '',
        page_num: 1,
        page_size: 10
      };

      setParams(myParams);
      getProductListFn(myParams);

    } else if (activeTabIndex === 1) {

      const myParams = {
        product_category_id: '',
        pageNum: 1,
        pageSize: 20,
        total: 0,
        totalPages: 0,
        keyword: ''
      };
      setParamsService(myParams);

      getServiceProductListFn(myParams);

    } else if (activeTabIndex === 2) {

      const myParams = {
        store_type: '',
        pageNum: 1,
        pageSize: 20,
        total: 0,
        totalPages: 0,
        keyword: ''
      };

      setParamsStore(myParams);

      getStoreListFn(myParams);
    }




  }

  const isFirstRender = useRef(true);
  const isFromUrl = useRef(false); // 标记是否来自URL参数


  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // 首次跳过
      return;
    }
    // 只有在不是从URL参数设置时才清空搜索框
    if (!isFromUrl.current) {
      // 切换 tab 时清空搜索框
      setKeyword('');
      // 注意：这里不再调用 handleReset()，因为 handleTabClick 已经处理了接口调用
    }
    isFromUrl.current = false; // 重置标记
  }, [activeTabIndex]);

  // 当切换tab时，重新加载对应类型的分类数据
  useEffect(() => {
    if (activeTabIndex === 0 || activeTabIndex === 1) {
      const categoryType = activeTabIndex === 1 ? 2 : 1;
      getProductCategoryAllList(categoryType).then((res) => {
        if (res.code === 200) {
          const data = res.data || [];
          //格式化分类数据
          const options = transformToCascaderOptions(data);
          setCascaderOptions(options);
        }
      });
    }
  }, [activeTabIndex]);


  //mounted 和unmounted
  useEffect(() => {
    //debugger
    const keywords = searchParams.get('keyword');
    const productCategoryId = searchParams.get('product_category_id');
    const activeTabIndexParam = searchParams.get('activeTabIndex');
    
    // 如果有 activeTabIndex 参数，设置对应的 tab
    if (activeTabIndexParam) {
      const tabIndex = parseInt(activeTabIndexParam);
      if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex <= 2) {
        isFromUrl.current = true; // 标记来自URL参数
        setActiveTabIndex(tabIndex);
      }
    }
    
    // 总是设置 keyword，无论是否为空
    console.log('Setting keyword from URL:', keywords);
    setKeyword(keywords || '');
    
    // 根据当前的 activeTabIndex 决定搜索类型
    const currentTabIndex = activeTabIndexParam ? parseInt(activeTabIndexParam) : activeTabIndex;
    
    if (currentTabIndex === 0 || !activeTabIndexParam) {
      // 默认加载商品的搜索
      const myParams = {
        ...params,
        product_title: keywords || '',
      }
      setParams(myParams);
      getProductListFn(myParams);
    } else if (currentTabIndex === 1) {
      // 服务搜索
      const myParams = {
        ...paramsService,
        keyword: keywords || '',
      };
      setParamsService(myParams);
      getServiceProductListFn(myParams);
    } else if (currentTabIndex === 2) {
      // 店铺搜索
      const myParams = {
        ...paramsStore,
        keyword: keywords || '',
      };
      setParamsStore(myParams);
      getStoreListFn(myParams);
    }

    //分类搜索
    if(productCategoryId){

      // 如果是单个ID，直接使用
      const categoryId = Number(productCategoryId);
      
      // 获取分类数据后再设置路径
      const categoryType = activeTabIndex === 1 ? 2 : 1;
      getProductCategoryAllList(categoryType).then((res) => {
        if (res.code === 200) {
          const data = res.data || [];
          //格式化分类数据
          const options = transformToCascaderOptions(data);
          setCascaderOptions(options);
          
          // 查找完整路径
          const path = findPathById(options, categoryId);
          if (path) {
            setCascaderValue(path);
            
            // 设置参数并加载数据
            const myParams = {
              ...params,
              product_category_id: categoryId,
            };
            setParams(myParams);
            getProductListFn(myParams);
            
            // 获取品牌数据
            getBrandList(categoryId);
          }
        }
      });

    } else {
      // 如果没有传递分类ID，正常加载分类数据
      const categoryType = activeTabIndex === 1 ? 2 : 1;
      getProductCategoryAllList(categoryType).then((res) => {
        console.log(res, 'getProductCategoryAllList');
        if (res.code === 200) {
          const data = res.data || [];
          //格式化分类数据
          const options = transformToCascaderOptions(data);
          setCascaderOptions(options);
        }
      });
    }

  }, []);


  

  return (
    <div className={styles['search-list']}>
      <SearchConponent keyword={keyword} getMessage={getMessage} currentTabIndex={activeTabIndex} />
      <div className={styles['tabs-list']}>
        {
          tabs.map((item, index) => {
            return <div
              className={`${styles['tabs-item']} ${activeTabIndex === index ? styles['active'] : ''}`}
              key={index}
              onClick={() => handleTabClick(index)}
            >
              {item.label}
            </div>
          })
        }
      </div>

      <div className={styles['search-Classification']}>

        {
          (activeTabIndex === 0 || activeTabIndex === 1) &&
          <div className={styles['Classification-text']}>
            {/* 暂时没有对应接口隐藏 */}
             {/* <div className={styles['Classification-title']}>
             <Button 
               className={`${styles['btn']} ${selectedFilter === 'Comprehensive' ? styles['btn-active'] : ''}`}
               onClick={() => handleFilterClick('Comprehensive')}
             >
               Comprehensive
             </Button>
             <Button 
               className={`${styles['btn']} ${selectedFilter === 'Sales' ? styles['btn-active'] : ''}`}
               onClick={() => handleFilterClick('Sales')}
             >
               Sales
             </Button>
             </div> */}
            <Cascader
              value={cascaderValue}
              options={cascaderOptions}
              style={{ width: 220 }}
              expandTrigger="hover"
              displayRender={displayRender}
              onChange={(value, selectedOptions) => {
                setCascaderValue(value || []);
                handleCascaderChange(value, selectedOptions);


            
                
                if(!value){
                  if (activeTabIndex === 0) {
                    // 商品tab清空分类
                    const myParams = {
                      ...params,
                      product_category_id: '',
                      product_category_brand_id: '',
                    };
                    setParams(myParams);
                    // 清空品牌列表
                    setBrandList([]);
                    // 调用API获取新的数据
                    getProductListFn(myParams);
                  } else if (activeTabIndex === 1) {
                    // 服务tab清空分类
                    const myParams = {
                      ...paramsService,
                      product_category_id: '',
                    };
                    setParamsService(myParams);
                    // 调用API获取新的数据
                    getServiceProductListFn(myParams);
                  }
                }
                

              }}
              placeholder={t('searchList.Selectacategory')}
              className={styles['cascader-selector']}
              changeOnSelect={false}
              // 只允许选择叶子节点
              fieldNames={{ label: 'label', value: 'value', children: 'children' }}
              showSearch={{
                filter: (inputValue, path) =>
                  path.some(option =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                  ),
                matchInputWidth: true,
                limit: 10, // 限制最多展示多少个匹配项（可选）
              }}
            />
          </div>
        }

        {
          activeTabIndex === 0 &&
          <div className={styles['Classification-text']}>
            <Select
              placeholder={t('searchList.Brand')}
              onChange={changeBrand}
              value={params.product_category_brand_id || undefined}
              style={{ width: 220 }}
            >
              {
                brandList.map((item) => (
                  <Select.Option value={item.product_category_brand_id} key={item.product_category_brand_id}>
                    {item.brand_name}
                  </Select.Option>
                ))
              }
            </Select>
          </div>
        }


        {
          activeTabIndex === 2 &&
          <div className={styles['Classification-text']}>
            <span className={styles['Classification-title']}>{t('searchList.StoreType')}:</span>
            <Select
              placeholder={t('searchList.StoreType')}
              onChange={changeStoreType}
              value={paramsStore.store_type}
              style={{ width: 220 }}
            >
              {
                storeTypeOptions.map((item) => (
                  <Select.Option value={item.value} key={item.value}>
                    {item.label}
                  </Select.Option>
                ))
              }

            </Select>
          </div>
        }


        <div className={styles['Classification-text']}>

          <Button
            className={styles['reset-btn']}
            onClick={handleReset}
          >{t('common.Reset')}</Button>
        </div>
      </div>

      {/* 产品列表 */}
      {
        activeTabIndex === 0 && <>
          <div className={styles['list-container']}>
            {goodsList.length > 0 ? (
              <>
                <ProductList goodsList={goodsList} isShowTop={false}/>
                <div className={styles['pagination-container']}>
                  <div className={styles['pagination-info']}>{t('searchList.Total')} {params.total} {t('searchList.Products')} </div>
                  <Pagination
                    onChange={paginationChange}
                    current={params.page_num}
                    pageSize={params.page_size}
                    total={params.total}
                    showSizeChanger={false}
                    responsive
                    hideOnSinglePage={params.totalPages <= 1}
                  />
                  <div className={styles['go-to-page']}>
                    {t('searchList.goto')}
                    <input
                      className={styles['page-input']}
                      type="text"
                      value={goToPage}
                      onChange={(e) => setGoToPage(e.target.value)}
                      onKeyDown={handlePageInputKeyDown}
                    />
                    {t('searchList.page')}
                    <Button
                      size="small"
                      style={{ marginLeft: 8 }}
                      onClick={handleGoToPage}
                    >
                      {t('searchList.GO')}
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <div className={styles['empty-state']}>
                <div className={styles['empty-icon']}>📦</div>
                <div className={styles['empty-text']}>{t('searchList.Noproductdata')}</div>
                <div className={styles['empty-subtitle']}>{t('searchList.Pleasetryfilters')}</div>
              </div>
            )}
          </div>
        </>
      }
      {/* 产品列表 */}


      {/* 服务列表 */}
      {
        activeTabIndex === 1 && <>
          <div className={styles['list-container']}>
            {serviceGoodsList.length > 0 ? (
              <>
                <ServiceProductList goodsList={serviceGoodsList} />
                <div className={styles['pagination-container']}>
                  <div className={styles['pagination-info']}>{t('searchList.Total')} {paramsService.total} {t('searchList.Products')}</div>
                  <Pagination
                    onChange={paginationChange}
                    current={paramsService.pageNum}
                    pageSize={paramsService.pageSize}
                    total={paramsService.total}
                    showSizeChanger={false}
                    responsive
                    hideOnSinglePage={paramsService.totalPages <= 1}
                  />
                  <div className={styles['go-to-page']}>
                    {t('searchList.goto')}
                    <input
                      className={styles['page-input']}
                      type="text"
                      value={goToPage}
                      onChange={(e) => setGoToPage(e.target.value)}
                      onKeyDown={handlePageInputKeyDown}
                    />
                    {t('searchList.page')}
                    <Button
                      size="small"
                      style={{ marginLeft: 8 }}
                      onClick={handleGoToPage}
                    >
                      {t('searchList.GO')}
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <div className={styles['empty-state']}>
                <div className={styles['empty-icon']}>🔧</div>
                <div className={styles['empty-text']}>{t('searchList.Noservicedata')}</div>
                <div className={styles['empty-subtitle']}>{t('searchList.Pleasetryfilters')}</div>
              </div>
            )}
          </div>
        </>
      }
      {/* 服务列表 */}


      {/* 店铺列表 */}
      {
        activeTabIndex === 2 && <>
          <div className={styles['list-container']}>
            {storeGoodsList.length > 0 ? (
              <>
                <StoreList goodsList={storeGoodsList} />
                <div className={styles['pagination-container']}>
                  <div className={styles['pagination-info']}>{t('searchList.Total')} {paramsStore.total} {t('searchList.Products')}</div>
                  <Pagination
                    onChange={paginationChange}
                    current={paramsStore.pageNum}
                    pageSize={paramsStore.pageSize}
                    total={paramsStore.total}
                    showSizeChanger={false}
                    responsive
                    hideOnSinglePage={paramsStore.totalPages <= 1}
                  />
                  <div className={styles['go-to-page']}>
                    {t('searchList.goto')}
                    <input
                      className={styles['page-input']}
                      type="text"
                      value={goToPage}
                      onChange={(e) => setGoToPage(e.target.value)}
                      onKeyDown={handlePageInputKeyDown}
                    />
                    {t('searchList.page')}
                    <Button
                      size="small"
                      style={{ marginLeft: 8 }}
                      onClick={handleGoToPage}
                    >
                      {t('searchList.GO')}
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <div className={styles['empty-state']}>
                <div className={styles['empty-icon']}>🏪</div>
                <div className={styles['empty-text']}>{t('searchList.Nostoredata')}</div>
                <div className={styles['empty-subtitle']}>{t('searchList.Pleasetryfilters')}</div>
              </div>
            )}
          </div>
        </>
      }
      {/* 店铺列表 */}

    </div>
  );
};

export default SearchList; 